import { Card } from '@/common/ui/Card'
import { Modal } from '@/common/ui/Modal'
import { Button } from '@/common/ui/Form/Button'
import { Icon } from '@/common/ui/Icon'
import { NonIdealState } from '@/common/ui/NonIdealState'
import { IntegrationsTable } from '@/app/entities/integrations/ui/integrationsTable'
import { IntegrationsForm } from '@/app/entities/integrations/ui/integrationsAddForm'
import { useOrgIntegrations } from '@/app/entities/integrations/model'
import { useCurrentOrg } from '@/app/entities/org/model'
import { useState } from 'react'
import type { GetIntegrationsResponse } from '@/common/types/api'

const INTEGRATIONS_EMPTY_TITLE = 'Подключите маркетплейс'
const INTEGRATIONS_EMPTY_DESCRIPTION =
    'Добавьте интеграцию с Wildberries или Ozon, чтобы синхронизировать описание товаров в один кабинет.'
const INTEGRATIONS_EMPTY_IMAGE_ALT = 'Нет подключённых интеграций'

export const IntegrationsPage = () => {
    const { data: currentOrg } = useCurrentOrg()
    const { data: integrations, isLoading: isIntegrationsLoading } = useOrgIntegrations(currentOrg?.id)
    const [editingIntegration, setEditingIntegration] = useState<GetIntegrationsResponse[0] | undefined>(undefined)
    const isEditMode = !!editingIntegration

    const handleEditIntegration = (integration: GetIntegrationsResponse[0]) => {
        setEditingIntegration(integration)
        const checkbox = document.getElementById('integrationModal') as HTMLInputElement
        if (checkbox) {
            checkbox.checked = true
        }
    }

    const handleAddIntegration = () => {
        setEditingIntegration(undefined)
        const checkbox = document.getElementById('integrationModal') as HTMLInputElement
        if (checkbox) {
            checkbox.checked = true
        }
    }

    const showIntegrationsEmptyState = !isIntegrationsLoading && integrations?.length === 0

    return (
        <>
            <div className='profile-content'>
                <h2 className='font-medium text-[20px]/[22px]'>Интеграция с маркетплейсами</h2>
            </div>
            <Card className='profile-content' tableScroll>
                {showIntegrationsEmptyState ? (
                    <div className='flex min-h-[240px] flex-1 items-center justify-center py-8'>
                        <NonIdealState
                            title={INTEGRATIONS_EMPTY_TITLE}
                            description={INTEGRATIONS_EMPTY_DESCRIPTION}
                            image='link-chain'
                            imageAlt={INTEGRATIONS_EMPTY_IMAGE_ALT}
                            actionSlot={
                                <Button size='xl' onClick={handleAddIntegration}>
                                    <Icon name='plus' size='lg' />
                                    Добавить интеграцию
                                </Button>
                            }
                        />
                    </div>
                ) : (
                    <IntegrationsTable
                        onEditIntegration={handleEditIntegration}
                        onClickAddIntegration={handleAddIntegration}
                    />
                )}

                <Modal id='integrationModal' modalClassName='md:w-2xl md:max-w-none!'>
                    <h3 className='text-lg font-bold'>
                        {isEditMode ? 'Редактировать интеграцию' : 'Добавить интеграцию'}
                    </h3>
                    <IntegrationsForm
                        editingIntegration={editingIntegration}
                        existingIntegrations={integrations || []}
                    />
                </Modal>
            </Card>
        </>
    )
}
